import {Component, OnInit} from '@angular/core';
import {IResource} from "../../../models/ressources/i-resource";
import {BasicResource} from "../../../models/ressources/basic-resource";
import {faEdit, faPlus, faTrash} from "@fortawesome/free-solid-svg-icons";
import {AuthentificationService} from "../../../services/authentification.service";
import {BehaviorSubject, firstValueFrom} from "rxjs";
import {MatDialog} from "@angular/material/dialog";
import {ConfirmationDialogComponent} from "../../utils/confirmation-dialog/confirmation-dialog.component";
import {CreateExerciceComponent} from "../create-exercice/create-exercice.component";
import {DatabaseService} from "../../../services/db/database.service";
import {DbKeys} from "../../../services/db/config/db-config";
import {FileService} from "../../../services/file/file.service";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-view-exercises',
  templateUrl: './view-exercises.component.html',
  styleUrls: ['./view-exercises.component.scss'],
  host: {'class': 'base-host-center styled-background'}
})
export class ViewExercisesComponent implements OnInit {
  protected exercices: IResource[];

  protected readonly faEdit = faEdit;
  protected readonly faTrash = faTrash;
  protected readonly faPlus = faPlus;

  protected isAuthenticated$: BehaviorSubject<boolean>;
  private readonly exercicePath: DbKeys;


  constructor(
    private readonly auth: AuthentificationService,
    private readonly matDialog: MatDialog,
    private readonly db: DatabaseService,
    private readonly fileService: FileService,
    private readonly snackbar: MatSnackBar,
  ) {
    this.exercicePath = DbKeys.exercices;
  }

  async ngOnInit(): Promise<void> {
    this.isAuthenticated$ = this.auth.isAuthenticated$;

    const data = await firstValueFrom(this.db.getdata(this.exercicePath));
    this.exercices = data.map(value => {
      const id = value.payload.doc.id;
      const name = value.payload.doc.get('name');
      const url = value.payload.doc.get('url');

      return new BasicResource(id, url, name);
    }).sort((a, b) => a.getName().localeCompare(b.getName()));
  }

  private async getExercices() {
    return [];
  }

  async openAddExerciceDialog() {
    const dialodRef = this.matDialog.open(CreateExerciceComponent)

    const value = await firstValueFrom(dialodRef.afterClosed());
    if (value instanceof BasicResource) {
      this.exercices.push(value);
      this.exercices = this.exercices.sort((a, b) => {
        return a.getName().localeCompare(b.getName())
      })
    }
  }

  /*openEditExerciceDialog() {
    this.matDialog.open(EditExerciceComponent)
  }*/

  openDeleteExerciceDialog(exercice: IResource) {
    this.matDialog.open(ConfirmationDialogComponent, {
      width: '250px',
      data: {
        title: 'Supprimer cet exercice',
        message: 'Le fichier sera supprimé definitivement',
        acceptButton: 'Supprimer',
        rejectButton: 'Annuler',
        onAccept: async () => {
          await this.deleteExercice(exercice)
        }
      }
    })
  }

  private async deleteExercice(exercice: IResource) {
    try {
      const url = exercice.getResourceUrl() ?? '';
      await this.deleteFile(url);

      const id = exercice.getResourceId();
      await this.deleteRef(id, this.exercicePath);

    } catch (e) {
      this.displayError(e);
    } finally {
      this.exercices = this.exercices.filter(e => e.getResourceId() !== exercice.getResourceId())
      this.snackbar.open(`${exercice.getName()} supprimé !`, 'OK', {duration: 5000});
    }
  }

  private async deleteFile(url: string) {
    try {
      await firstValueFrom(this.fileService.deleteFile(url));
    } catch (e) {
      throw new FileDeleteError();
    }
  }

  private async deleteRef(id: string, path: string) {
    try {
      await this.db.deleteData(path, id);
    } catch (e) {
      throw new RefStorageDeleteError();
    }
  }

  private displayError(e: any) {
    if (e instanceof Error) this.snackbar.open(`Erreur : ${e.message}`)
    else this.snackbar.open(`Erreur inconnue : ${e}`)
  }

}


class FileDeleteError extends Error {
  constructor() {
    super('Erreur lors de la suppression du fichier.');
  }
}

class RefStorageDeleteError extends Error {
  constructor() {
    super('Erreur lors de la suppression en base de données.');

  }

}
